<bricks-app-frame>
  <bricks-app-toolbar
    [class.dev-mode]="devMode()"
    title=""
    [showCustomLogo]="true"
    [attributeLabel]="stagename ? 'Stage' : ''"
    [attributeValue]="stagename"
    [attributeColor]="devMode() ? 'error' : 'accent'">
    <img app-logo src="/assets/logo.svg" alt="EnBW VK Portal Logo" width="400" [routerLink]="['/']" />

    <bricks-user-menu
      userInfo1="{{ authService.currentUser()?.email }}"
      userInfo2="{{ userRole }}"
      [showFeedback]="false"
      [languageConfig]="false"
      [userInfo1Primary]="true"
      (logOut)="logout()">
    </bricks-user-menu>
  </bricks-app-toolbar>
  <bricks-sidebar-container>
    <bricks-sidebar
      [open]="false"
      [openable]="true"
      [mode]="'side'"
      [hideDefaultFooter]="true"
      [closeSidebarOnMenuItemClick]="false">
      @for (item of menuItems; track item.routerPath) {
        <bricks-sidebar-menu-item
          [label]="item.title"
          [icon]="item.iconName"
          [isSelected]="isActive(item.routerPath)"
          (itemClick)="navigateTo(item.routerPath)">
        </bricks-sidebar-menu-item>
      }
      <div custom-footer class="sidebar-footer">
        <span class="app-version" data-testid="app-version">Version {{ appVersion }}</span>
        <span class="app-version-sep" aria-hidden="true">•</span>
        <a href="https://www.enbw.com/impressum/" target="_blank" rel="noopener noreferrer">Impressum</a>
      </div>
    </bricks-sidebar>
    <router-outlet></router-outlet>
  </bricks-sidebar-container>
</bricks-app-frame>

<app-scroll-top-button></app-scroll-top-button>
